import { BaseTag }   from "mixs/base/base_mixin";

class Index extends BaseTag {
  init(){
    super.init();
    this.watch();
  }
  onClickDownloadCsv(){
    let uri = '/csv/orders.csv' + window.location.search;
    window.open(uri, '_blank');
  }
}

riot.mixin('orders.index', Index as riot.TagMixin)
